import React__default, { useState } from 'react';
import { useLazyRef } from '@shopify/react-hooks';
import { PortalsManager } from '@shopify/polaris';
import { ShortcutProvider } from '@shopify/react-shortcuts';
import { OptionalProviders } from './OptionalProviders.mjs';
import styles from './AppProvider.scss.mjs';
import { UniqueIdFactory, globalIdGeneratorFactory } from '../../utilities/unique-id/unique-id-factory.mjs';
import { FeaturesProvider } from '../FeaturesProvider/FeaturesProvider.mjs';
import { MediaQueryProvider } from '../MediaQueryProvider/MediaQueryProvider.mjs';
import { UniqueIdFactoryContext } from '../../utilities/unique-id/context.mjs';
import { FrameProvider } from '../FrameProvider/FrameProvider.mjs';

function AppProvider({
  features,
  children
}) {
  const [appProvider, setAppProvider] = useState(null);
  const uniqueIdFactory = useLazyRef(() => new UniqueIdFactory(globalIdGeneratorFactory));
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles.AppProvider,
    ref: setAppProvider
  }, /*#__PURE__*/React__default.createElement(ShortcutProvider, null, /*#__PURE__*/React__default.createElement(FeaturesProvider, {
    features: features
  }, /*#__PURE__*/React__default.createElement(MediaQueryProvider, null, /*#__PURE__*/React__default.createElement(UniqueIdFactoryContext.Provider, {
    value: uniqueIdFactory.current
  }, /*#__PURE__*/React__default.createElement(FrameProvider, null, /*#__PURE__*/React__default.createElement(OptionalProviders, {
    features: features
  }, /*#__PURE__*/React__default.createElement(PortalsManager, {
    container: appProvider
  }, children))))))));
}

export { AppProvider };
